/*
 * Default export needs to be named this to query the Contentful space
 * as well as for the TS types to be generated
 * See static/bundles/page/lib/network/server.ts for more info
 */
import contentfulGql from 'js/lib/contentfulGql';

export const tutorialsPageQuery = contentfulGql`#graphql
  query Tutorial($slug: String!, $preview: Boolean!) {
    tutorialsCollection(preview: $preview, where: { slug: $slug }, limit: 1) {
      items {
        ...TutorialsFields
      }
    }
  }
  fragment TutorialsFields on Tutorials {
    title
    slug
    intro
    featuredImage {
      title
      description
      width
      height
      url(transform: {
        width: 1500,
        height: 680,
        resizeStrategy: FILL,
        resizeFocus: FACES,
        format: JPG_PROGRESSIVE,
        quality: 60
      })
    }
    bodyText
    tags
    disableCrawlerIndexing
    metaTitle
    metaDescription
    canonicalUrl
    previousTutorial {
      label
      route
    }
    nextTutorial {
      label
      route
    }
    sys {
      firstPublishedAt
      publishedAt
    }
  }
`;

export const tutorialHubQuery = contentfulGql`#graphql
  fragment HubTutorialFields on Tutorials {
    slug
    title
    intro
    featuredImage {
      title
      description
      width
      height
      url(transform: {
        width: 300,
        height: 136,
        resizeStrategy: FILL,
        resizeFocus: FACES,
        format: JPG_PROGRESSIVE,
        quality: 60
      })
    }
    sys {
      firstPublishedAt
    }
  }
  query TutorialHub {
    tutorialsCollection(limit: 15) {
      items {
        ...HubTutorialFields
      }
    }
  }
`;
